import { PollDetailPage } from '@/components/governance/poll-detail-page'

export function CommitteePollDetail() {
  return <PollDetailPage basePath="/committee/polls" />
}
